import React from 'react';
import { Link } from 'react-router-dom';

const NonAuthNav = () => {
  return <Link to="/login">Login</Link>;
};

export default NonAuthNav;
